import React, { lazy } from 'react';
import { GridView } from '@mui/icons-material';
import RouterGuard from '../components/router-guard';
import MainLayout from '../pages/layout';
import { CustomRouteObject } from './types';
import SpecialPriceApproval from '@/pages/specialPriceTable/specialPriceApproval/specialPriceApproval';
import PreviewSpecialsPdf
  from '@/pages/specialPriceTable/searchSpecialPriceList/components/driverCarriesSpecialRateMeterPdf/previewSpecialsPdf/previewSpecialsPdf';
import PreviewSpecialsMailPdf
  from '@/pages/specialPriceTable/searchSpecialPriceList/components/driverCarriesSpecialRateMeterPdf/previewSpecialsMailPdf/previewSpecialsMailPdf';
import LabelPrinterPdf
  from '@/pages/specialPriceTable/searchSpecialPriceList/components/driverCarriesSpecialRateMeterPdf/labelPrinterPdf/labelPrinterPdf';
import { Outlet } from 'react-router-dom';

const Login = lazy(() => import('../pages/login'));
const AddSpecialOfferSheet = lazy(() => import('../pages/specialPriceTable/addSpecialOfferSheet/addSpecialOfferSheet'));
const SearchSpecialPriceList = lazy(() => import('../pages/specialPriceTable/searchSpecialPriceList/searchSpecialPriceList'));

// @ts-ignore
// @ts-ignore
const routes: CustomRouteObject[] = [
  {
    path: '/',
    element: <RouterGuard element={<MainLayout/>} valid={true}></RouterGuard>,
    children: [
      {
        title: 'SpecialPrice',
        meta: { icon: <GridView/> },
        path: '/special-price-table',
        children: [
          {
            title: 'AddSpecialOfferSheet',
            path: 'add-special-offer-sheet',
            element: <AddSpecialOfferSheet/>,
            meta: { icon: <GridView/> },
          },
          {
            title: 'SearchSpecialPriceList',
            path: 'search-special-price-list',
            element: <SearchSpecialPriceList />,
            meta: { icon: <GridView/> },
          },
          {
            title: '预览司机带特价表',
            path: 'search-special-price-list/preview-specials-pdf',
            element: <PreviewSpecialsPdf/>,
            meta: { icon: <GridView/> },
            hidden: true,
          },
          {
            title: '预览寄出去特价表',
            path: 'search-special-price-list/preview-specials-mail-pdf',
            element: <PreviewSpecialsMailPdf/>,
            meta: { icon: <GridView/> },
            hidden: true,
          },
          {
            title: '预览邮寄出去标签',
            path: 'search-special-price-list/label-printer-pdf',
            element: <LabelPrinterPdf/>,
            meta: { icon: <GridView/> },
            hidden: true,
          },
          {
            title: 'SpecialPriceApproval',
            path: 'special-price-approval',
            element: <SpecialPriceApproval/>,
            meta: { icon: <GridView/> },
          },
        ],
      },
    ],
  },
  { path: '/login', hidden: true, element: <Login/> },
  { path: '*', hidden: true, element: <div>404</div> },
];

export default routes;
